import env from "../../../configs/envConfig";
import { useChat } from "../contexts/ChatContext";
import { useNewTemplate } from "../contexts/NewTemplateContext";
import { debugLog } from "../../../configs/loggingConfig";

const NewChatButton = () => {
    const { leaveChat } = useChat(); 
    const { setChatTemplate } = useNewTemplate();

    const handleClick = async (e) => {
        e.preventDefault();
        debugLog.log("New Chat Started");
        setChatTemplate(undefined);
        await leaveChat();
        document.title = `${env.REACT_APP_BRANDING_SYMPHONY_NAME ?? "Maestro"} - New Chat`;
    }

    return (
        <a
            className="a-button a-button--outline l-mb-sm"
            href={`/${env.REACT_APP_BRANDING_APP_PATH ?? "maestro"}/chat`}
            onClick={handleClick}
        >
            Start New Chat
        </a>
    );
};

export default NewChatButton;
